export default "__VITE_ASSET__CpzcfdqR__"